"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Title = exports.Root = void 0;
var _mui = require("@ori-ui/mui");
var _styles = require("../styles");
const Root = exports.Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        maxWidth: 600,
        margin: 'auto',
        marginBottom: theme.spacing(6),
        [theme.breakpoints.up('sm')]: {
            marginBottom: theme.spacing(10)
        }
    };
});
const Title = exports.Title = (0, _mui.styled)(_styles.UnifiedSkeleton)((param)=>{
    let { theme } = param;
    return {
        width: 155,
        height: 47,
        [theme.breakpoints.up('sm')]: {
            width: 205,
            height: 62
        }
    };
});
